module.exports = __webpack_public_path__ + "img/logo-icon-3.370e47c1.png";